module.exports = __webpack_public_path__ + "img/logo-prod.20264a5f.png";